import {Link} from "react-router-dom";
import {formatAchievementDate} from "../../helpers";
import type {AchievementDataPointSidebarProps} from "./types";
import './data-point-sidebar.scss';

export default function AchievementDataPointSidebar({title, dataPoints}: AchievementDataPointSidebarProps) {
    return (
        <aside className="achievement-data-sidebar" aria-labelledby="achievement-data-sidebar-title">
            <div className="achievement-data-sidebar__header">
                <div>
                    <p className="achievement-data-sidebar__eyebrow">Counted toward this achievement</p>
                    <h2 id="achievement-data-sidebar-title">{title}</h2>
                </div>
                <strong className="achievement-data-sidebar__count" aria-label={`${dataPoints.length} counted`}>
                    {dataPoints.length.toLocaleString()}
                </strong>
            </div>

            {dataPoints.length ? (
                <ol className="achievement-data-sidebar__list">
                    {dataPoints.map((dataPoint, index) => (
                        <li className="achievement-data-sidebar__item" key={`${dataPoint.label}-${dataPoint.locationLabel ?? index}`}>
                            <span className="achievement-data-sidebar__number" aria-hidden="true">{index + 1}</span>
                            <div>
                                {dataPoint.detailPath ? (
                                    <Link to={dataPoint.detailPath}><strong>{dataPoint.label}</strong></Link>
                                ) : <strong>{dataPoint.label}</strong>}
                                {dataPoint.locationLabel ? (
                                    <span>
                                        First counted at{' '}
                                        {dataPoint.locationDetailPath ? (
                                            <Link to={dataPoint.locationDetailPath}>{dataPoint.locationLabel}</Link>
                                        ) : dataPoint.locationLabel}
                                    </span>
                                ) : null}
                                {dataPoint.firstObservedDate ? (
                                    <span>{formatAchievementDate(dataPoint.firstObservedDate)}</span>
                                ) : null}
                            </div>
                        </li>
                    ))}
                </ol>
            ) : (
                <p className="achievement-data-sidebar__empty">No qualifying data points are available yet.</p>
            )}
        </aside>
    );
}
